module.exports = __webpack_public_path__ + "static/apple-icon-144x144-24bf420805f254e067891fd6fc93ced5.png";